<template>
  <v-card class="pa-4">
    <v-dialog v-model="alertDialog" max-width="900">
      <ManageAlert
        title="Novo alerta"
        :key="dialogKey"
        :alert="alert"
        :newAlert="true"
        @close="alertDialog = false"
      />
    </v-dialog>

    <h3 class="text-center">
      {{ isEditing ? 'Editar' : 'Adicionar' }} documento
    </h3>

    <v-form ref="form" v-model="formValid">
      <v-row class="ma-0" dense>
        <v-col cols="12">
          <label for="name">Nome</label>
          <v-text-field
            v-model="document.identification"
            outlined
            class="primary-input"
            :rules="[(v) => !!v || 'Nome obrigatório']"
            placeholder="Nome do documento"
            hide-details="auto"
            :loading="loading"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <label for="name">Pastas</label>
          <v-select
            v-model="document.folderId"
            outlined
            append-icon="mdi-chevron-down"
            class="primary-input"
            :disabled="!!parentFolderId"
            :items="folders"
            item-text="name"
            item-value="id"
            placeholder="Pastas do documento"
            hide-details="auto"
            :loading="folderLoading || loading"
          ></v-select>
        </v-col>
        <v-col cols="12">
          <label for="name">Data de expiração</label>
          <v-menu
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formatDate(document.expireDate)"
                placeholder="Data de Expiração"
                class="primary-input"
                outlined
                hide-details="auto"
                prepend-inner-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
                autocomplete="off"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        x-small
                        color="#DC143C"
                        v-bind="attrs"
                        v-on="on"
                        @click="createAlert"
                      >
                        <v-icon small>mdi-bell-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('Criar alerta') }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </template>
            <date-picker
              ref="datepicker"
              style="width: 100%"
              v-model="document.expireDate"
              mode="dateTime"
              is24hr
              :popover="{ visibility: 'click', positionFixed: 'true' }"
            >
            </date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12">
          <label for="name">Documento</label>
          <v-file-input
            :placeholder="
              isEditing
                ? `${document.identification}.${document.extension}`
                : 'Upload do Documento'
            "
            v-model="document.file"
            outlined
            prepend-icon=""
            hide-details="auto"
            :disabled="isEditing"
            class="primary-input"
            :rules="
              isEditing
                ? []
                : [(v) => !!v || 'Upload do Documento é obrigatório']
            "
            prepend-inner-icon="mdi-file"
            :loading="loading"
          ></v-file-input>
        </v-col>
        <v-col cols="12" class="d-flex justify-space-between">
          <v-btn
            class="primary-button ma-1"
            depressed
            :disabled="formLoading"
            @click="$emit('close')"
          >
            Cancelar
          </v-btn>
          <v-btn
            class="secondary-button ma-1"
            depressed
            :loading="formLoading"
            :disabled="!formValid"
            @click="submit"
          >
            {{ isEditing ? 'Atualizar' : 'Adicionar' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import moment from 'moment'
import ManageAlert from '../../Alert/components/manageAlert/ManageAlert.vue'
export default {
  name: 'manageDocument',

  components: {
    ManageAlert,
  },

  props: {
    documentId: Number,
    parentFolderId: Number,
  },

  data() {
    return {
      alert: {},
      isEditing: false,
      dialogKey: false,
      alertDialog: false,
      apiService: new ApiService(),
      document: {},
      loading: false,
      folders: [],
      formValid: false,
      folderLoading: false,
      formLoading: false,
    }
  },

  created() {
    this.getFolders()
    if (this.documentId) {
      this.isEditing = true
      this.document.file = this.document.filePath
      this.getDocument()
    }

    if (this.parentFolderId) this.document.folderId = this.parentFolderId
  },

  methods: {
    formatDate() {
      return this.document.expireDate
        ? moment(this.document.expireDate).format('DD/MM/yyyy')
        : ''
    },

    createAlert() {
      if (!this.document.identification) {
        this.$toast.warning(
          'Adicione um nome ao documento para prosseguir com o alerta'
        )
        return
      }

      this.alert = {
        description: `Identificação: ${this.document.identification}`,
        eventDate: this.document.expireDate
          ? this.document.expireDate
          : new Date(),
        alertDateTime: this.document.expireDate
          ? this.document.expireDate
          : new Date(),
        alertModule: 0,
        InstitutionId: JSON.parse(localStorage.getItem('institution')).id,
      }
      this.dialogKey = !this.dialogKey
      this.alertDialog = true
    },

    getDocument() {
      this.loading = true
      this.apiService
        .get(`commonAreaDocument/${this.documentId}`)
        .then((response) => {
          this.document = response.content

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    getFolders() {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id

      this.folderLoading = true
      this.apiService
        .get(`CommonAreaDocumentFolder/${institutionId}`)
        .then((response) => {
          this.folders = response.content
          this.folderLoading = false
        })
        .catch(() => {
          this.folderLoading = false
        })
    },

    submit() {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id
      this.document.institutionId = institutionId

      if (this.isEditing) this.edit()

      const reader = new FileReader()
      reader.readAsDataURL(this.document.file)

      reader.onload = () => {
        const extension = this.document.file.name.split('.').pop()
        const base64String = reader.result

        this.document.filePath = base64String
        this.document.extension = extension

        const fileSize = this.document.file.size
        this.document.size = fileSize

        this.add()
      }
    },

    edit() {
      if (!this.$refs.form.validate()) return

      this.formLoading = true

      this.apiService
        .post('commonAreaDocument/edit', this.document)
        .then((response) => {
          this.$toast.success('Arquivo atualizado com sucesso!')
          this.$emit('success')
          this.formLoading = false
        })
        .catch(() => {
          this.formLoading = false
        })
    },

    add() {
      if (!this.$refs.form.validate()) return

      this.formLoading = true
      this.apiService
        .post('commonAreaDocument/add', this.document)
        .then((response) => {
          this.$toast.success('Arquivo adicionado com sucesso!')
          this.$emit('success')
          this.$emit('totalFilesUpdate')
          this.formLoading = false
        })
        .catch(() => {
          this.formLoading = false
        })
    },
  },
}
</script>

<style></style>
